import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Multiselect from '../../MultiSelect'

const CreateModal = ({ editData, categries, handleRefresh, subcategories }) => {
  const uploadImage = useUploadImage()
  const { app_id } = useParams()
  const AppService = useAppServices()
  const [user] = useUserInfo()

  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState('') 
  const [selectedCategoryObj, setSelectedCategoryObj] = useState(null)

  useEffect(() => {
    if (editData?.category) {
      const categoryValue = editData.category.value || editData.category[0]?.value || ''
      setSelectedCategory(categoryValue)
      const found = categries.find((cat) => cat.value === categoryValue)
      setSelectedCategoryObj(found || null)
    }
  }, [editData, categries])

  const filteredSubcategories = selectedCategory
    ? subcategories.filter((subcat) => subcat.category.value === selectedCategory)
    : []

  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleCategoryChange = (e) => {
      const selectedValue = e.target.value
      setSelectedCategory(selectedValue)
      const category = categries.find(cat => cat.value === selectedValue)
      setSelectedCategoryObj(category || null)
    }

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      const categoryObj = categries.find(cat => cat.value === selectedCategory)

      const payload = {
        _id: editData._id,
        category: {
          id: categoryObj?.value,
          label: categoryObj?.label,
          ...categoryObj
        },
        subcategory: e.target?.subcategory?.value
          ? JSON.parse(e.target?.subcategory?.value)
          : [],
        question: e.target.question?.value,
        answer: e.target.answer?.value,
        type: e.target.type?.value,
        status: e.target.status?.value,
      }

      const { response } = await AppService.faq.update({ payload })
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      height: '80vh',
      overflowY: 'auto',
      bgcolor: 'background.paper',
      p: 4,
    }

    return (
      <MDModal open={open} onClose={onClose}>
        <MDBox component="form" onSubmit={handleSubmit} sx={style}>
          <MDTypography variant="h5" mb={2}>
            Edit FAQ
          </MDTypography>

          <MDBox mb={2}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Category
            </MDTypography>
            <MDInput
              select
              name="category"
              fullWidth
              required
              SelectProps={{ native: true }}
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              <option value="">Select Category</option>
              {categries.map((cat) => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </MDInput>
          </MDBox>

          {filteredSubcategories.length > 0 && (
            <MDBox mb={2}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Sub Category
              </MDTypography>
              <Multiselect
                data={filteredSubcategories}
                edit_data={editData?.subcategory || []}
                isMulti={true}
                name="subcategory"
              />
            </MDBox>
          )}

          <MDBox mb={2}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Question
            </MDTypography>
            <MDInput
              label="Question"
              name="question"
              defaultValue={editData?.question}
              fullWidth
            />
          </MDBox>

          <MDBox mb={2}>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Answer
            </MDTypography>
            <TextareaAutosize
              defaultValue={editData?.answer}
              name="answer"
              minRows={3}
              style={{ width: '100%' }}
            />
          </MDBox>

          <MDBox mb={2}>
            <MDTypography variant="button">Type</MDTypography>
            <MDInput
              select
              name="type"
              defaultValue={editData?.type || 'agency'}
              fullWidth
              required
              SelectProps={{ native: true }}
            >
              <option value="agency">Agency</option>
              <option value="levelupmarketplace">Levelupmarketplace</option>
              <option value="appcreator">Appcreator</option>
            </MDInput>
          </MDBox>

          <MDBox mb={2}>
            <MDTypography variant="button">Status</MDTypography>
            <MDInput
              select
              name="status"
              fullWidth
              required
              SelectProps={{ native: true }}
              defaultValue={editData?.status || 'Publish'}
            >
              <option value="Publish">Publish</option>
              <option value="Draft">Draft</option>
            </MDInput>
          </MDBox>

          <MDBox display="flex" justifyContent="flex-end">
            <MDButton
              variant="gradient"
              color="primary"
              type="button"
              sx={{ mt: 4, mb: 1 }}
              onClick={closeAddProduct}
            >
              Close
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              sx={{ mt: 4, mb: 1, ml: 1 }}
              loading={processing}
              disabled={processing}
            >
              Update
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton variant="contained" color="warning" size="small" onClick={handlemodal}>
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
